export var FETCH_BETTING_HISTORY = 'FETCH_BETTING_HISTORY';
export var SUCCESS_FETCH_BETTING_HISTORY = 'SUCCESS_FETCH_BETTING_HISTORY';
export var FAILURE_FETCH_BETTING_HISTORY = 'FAILURE_FETCH_BETTING_HISTORY';
export var CLEAR_BET_HISTORY = 'CLEAR_BET_HISTORY';



// WEBPACK FOOTER //
// ./src/actions/betting-history/bettingHistory.js